import { defineComponent as _defineComponent } from 'vue'
import { store } from '@/store';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'PrivateOrProfessionalSelector',
  setup(__props) {

const modes = computed<IMode[]>(() => store.getters['app/modes']);

return { __sfc: true,modes }
}

})